<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="setting()">
      <v-icon color="teal">settings</v-icon>
    </v-btn>
    <span>Settings</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    setting() {
      this.$emit("setting");
    }
  }
};
</script>

<style>
</style>
